<div class="header">
  <h2>{{isEditingMode ? 'Edit':'Create'}} Group</h2>
</div>
<mat-card>
  
  <div class="mat-elevation-z0">
    <h3 class="sub-heading inline-item">Group Form</h3>
      <form [formGroup]="createGroupForm" (ngSubmit)="createGroup()" class="group-form">
        <div class="inline-item">
          <mat-form-field appearance="outline" class="full-width">
            <input matInput formControlName="name" placeholder="Group Name" />
          </mat-form-field>
        </div>
        <div class="inline-button">
          <button mat-flat-button type="submit" color="primary"
          [disabled]="createGroupForm.invalid">{{isEditingMode ? 'Save' : 'Create'}}
          Group</button>
        </div>
      </form>
      <br />
      <div class="customers-wrapper">

      <div class="mat-elevation-z0">
        <!-- <mat-expansion-panel [expanded]="true"> -->
          <!-- <mat-expansion-panel-header> -->
            <!-- <mat-panel-title> -->
              <!-- Customers -->
            <!-- </mat-panel-title> -->
            <!-- <mat-panel-description> -->
              <!-- Choose Customers -->
            <!-- </mat-panel-description> -->
          <!-- </mat-expansion-panel-header> -->
          <div class="filter-wrap">
            <form [formGroup]="filterForm" (ngSubmit)="onSubmitFilterForm()">
              <mat-form-field class="inline-item" appearance="outline">
                <mat-label>Country</mat-label>
                <mat-select formControlName="city__state__country">
                  <mat-option [value]=""></mat-option>
                  <mat-option *ngFor="let country of countries" [value]="country.id">
                    {{ country.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="inline-item" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput formControlName="search" placeholder="Search customer" />
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
              <button mat-flat-button type="submit" color="primary">Filter Customers</button>
            </form>
          </div>
          <div class="table-container">
            <table mat-table [dataSource]="customerList?.results" matTableResponsive>
              <ng-container matColumnDef="checkbox">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let customer">
                  <mat-icon *ngIf="selectedCustomersIDs.indexOf(customer.user_id) == -1" (click)="addCustomer(customer)" color="primary" class="icon">add</mat-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="number">
                <th mat-header-cell *matHeaderCellDef> No. </th>
                <td mat-cell *matCellDef="let i=index"> {{ i + 1}} </td>
              </ng-container>

              <ng-container matColumnDef="customerCode">
                <th mat-header-cell *matHeaderCellDef> Customer Code </th>
                <td mat-cell *matCellDef="let customer"> {{customer.code}}</td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let customer"> 
                  {{customer.email}}
                </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let customer"> <span class="company">{{customer.company | slice:0:20}}<span
                      *ngIf="customer.company?.length > 20">...</span></span></td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="customersDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: customersDisplayedColumns;"></tr>
            </table>
            <mat-paginator [length]="customerList?.count" (page)="onPaginateChange($event)" [pageIndex]="pageIndex"
            [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions">
          </mat-paginator>
          </div>
        <!-- </mat-expansion-panel> -->
      </div>
      <div class="mat-elevation-z0">
        <h3>Selected Customers({{selectedCustomers.length}})</h3>
        <br />
      <table mat-table [dataSource]="selectedCustomers" style="margin-top: 7px" matTableResponsive #selectedTable>
        <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let i=index">
            <mat-icon (click)="removeCustomer(i)" color="accent" class="icon">remove</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef> No. </th>
          <td mat-cell *matCellDef="let i=index"> {{ i + 1}} </td>
        </ng-container>

        <ng-container matColumnDef="customerCode">
          <th mat-header-cell *matHeaderCellDef> Customer Code </th>
          <td mat-cell *matCellDef="let customer"> {{customer.code}}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let customer"> <span class="company">{{customer.company | slice:0:20}}<span
                *ngIf="customer.company?.length > 20">...</span></span></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="selectedCustomersDisplayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: selectedCustomersDisplayedColumns;"></tr>
      </table>
      </div>
    </div>

  </div>
</mat-card>
